import { Shield } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type AccessDeniedProps = {
  description?: string;
};

export const AccessDenied = ({
  description = "You do not have permission to access this page.",
}: AccessDeniedProps) => (
  <div className="flex h-full overflow-hidden p-2 sm:p-3">
    <div className="flex min-h-0 flex-1 items-center justify-center">
      <Card className="mx-4 w-full max-w-md">
        <CardHeader>
          <CardTitle>Access Denied</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="py-8 text-center">
            <Shield className="mx-auto mb-4 h-16 w-16 text-destructive" />
            <h3 className="mb-2 text-lg font-semibold text-foreground">
              Permission Required
            </h3>
            <p className="mb-4 text-muted-foreground">{description}</p>
            <p className="text-sm text-muted-foreground">
              Please contact your administrator if you believe this is an error.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  </div>
);
